/* BJ Kaching extender color sync v12.1 - hidden programmatic dropdown sync
   Main bundle item #n -> extender #n, without the old 1.5s delay.
   Extender dropdown changes are never resynced/reverted. */
(function () {
  if (window.__bjKachingExtenderIndexSyncV12) return;
  window.__bjKachingExtenderIndexSyncV12 = true;

  var timers = [];
  var syncing = false;
  var observer = null;

  function clean(text) { return String(text || '').replace(/\s+/g, ' ').trim(); }
  function color(text) {
    var m = clean(text).match(/18K\s+(?:Gold|Silver)\s+Plated/i);
    return m ? m[0].replace(/18k/i, '18K').replace(/gold/i, 'Gold').replace(/silver/i, 'Silver').replace(/plated/i, 'Plated') : '';
  }
  function value(combo) {
    var holder = combo && combo.closest('.kaching-bundles-option');
    return color((holder && holder.getAttribute('data-value')) || (combo && (combo.innerText || combo.textContent)));
  }
  function pageColor() {
    var text = clean(document.body && (document.body.innerText || document.body.textContent));
    var m = text.match(/Color:\s*(18K\s+(?:Gold|Silver)\s+Plated)/i);
    return m ? color(m[1]) : '';
  }
  function selectedMainBar() {
    return Array.prototype.slice.call(document.querySelectorAll('.kaching-bundles__bar--selected')).find(function (bar) {
      return !bar.closest('.kaching-bundles__checkbox-upsells');
    });
  }
  function mains() {
    var bar = selectedMainBar();
    return bar ? Array.prototype.slice.call(bar.querySelectorAll('[role="combobox"][aria-label="Color"]')) : [];
  }
  function exts() {
    return Array.prototype.slice.call(document.querySelectorAll('.kaching-bundles__checkbox-upsells [role="combobox"][aria-label="Color"]'));
  }
  function fire(node, type) {
    if (!node) return;
    node.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
  }
  function tap(node) { ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (t) { fire(node, t); }); }
  function findOption(combo, target) {
    var listId = combo && combo.getAttribute('aria-controls');
    var list = listId && document.getElementById(listId);
    var options = list ? Array.prototype.slice.call(list.querySelectorAll('[role="option"]')) : [];
    if (!options.length) options = Array.prototype.slice.call(document.querySelectorAll('[role="listbox"] [role="option"], .kaching-bundles__swatch-dropdown__option[role="option"]'));
    return options.find(function (opt) { return color(opt.getAttribute('data-value') || opt.innerText || opt.textContent) === target; });
  }
  function restoreViewport(x, y) {
    if (typeof y !== 'number') return;
    if (Math.abs(window.scrollY - y) > 2 || Math.abs(window.scrollX - x) > 2) {
      window.scrollTo({ left: x, top: y, behavior: 'auto' });
    }
  }
  function ensureSyncStyle() {
    if (document.getElementById('bj-kaching-programmatic-sync-style')) return;
    var style = document.createElement('style');
    style.id = 'bj-kaching-programmatic-sync-style';
    style.textContent = '.bj-kaching-programmatic-sync [role="listbox"][id^="swatch-dropdown-"], .bj-kaching-programmatic-sync .kaching-bundles__swatch-dropdown { opacity: 0 !important; pointer-events: none !important; transition: none !important; }';
    document.head.appendChild(style);
  }
  function setOne(combo, target, done) {
    if (!combo || !target || value(combo) === target) { done(); return; }

    ensureSyncStyle();
    var lockX = window.scrollX;
    var lockY = window.scrollY;
    var html = document.documentElement;
    html.classList.add('bj-kaching-programmatic-sync');
    tap(combo);
    restoreViewport(lockX, lockY);
    window.setTimeout(function () {
      restoreViewport(lockX, lockY);
      var option = findOption(combo, target);
      if (option) tap(option);
      restoreViewport(lockX, lockY);

      window.setTimeout(function () {
        restoreViewport(lockX, lockY);
        html.classList.remove('bj-kaching-programmatic-sync');
        done();
      }, 35);
    }, 25);
  }
  function syncOnce(done) {
    if (syncing) { done && done(); return; }
    var main = mains();
    var ext = exts();
    var fallback = pageColor();
    if (!ext.length || (!main.length && !fallback)) { done && done(); return; }

    syncing = true;
    var i = 0;
    function next() {
      if (i >= ext.length) { syncing = false; done && done(); return; }
      var target = value(main[i] || main[main.length - 1]) || fallback;
      setOne(ext[i], target, function () { i += 1; next(); });
    }
    next();
  }
  function clearTimers() {
    timers.forEach(function (timer) { window.clearTimeout(timer); });
    timers = [];
  }
  function scheduleFast() {
    clearTimers();
    [0, 60, 140, 320].forEach(function (delay) {
      timers.push(window.setTimeout(function () { syncOnce(function () {}); }, delay));
    });
  }
  function scheduleInit() {
    clearTimers();
    [0, 60, 250, 700, 1400, 2500].forEach(function (delay) {
      timers.push(window.setTimeout(function () { syncOnce(function () {}); }, delay));
    });
  }
  function isMainTarget(target) {
    if (!target || !target.closest) return false;
    if (target.closest('.kaching-bundles__checkbox-upsells')) return false;
    return !!target.closest('.kaching-bundles__bar, variant-selects, variant-radios, .product-form__input, [role="listbox"]');
  }
  function wireObserver() {
    if (!window.MutationObserver || observer) return;
    observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        var target = mutation.target;
        return target && target.closest && isMainTarget(target);
      });
      if (shouldSync) scheduleFast();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-value', 'aria-selected', 'aria-expanded']
    });
  }

  document.addEventListener('click', function (e) { if (isMainTarget(e.target)) scheduleFast(); }, true);
  document.addEventListener('change', function (e) { if (isMainTarget(e.target)) scheduleFast(); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { wireObserver(); scheduleInit(); });
  else { wireObserver(); scheduleInit(); }
  window.addEventListener('load', scheduleInit);
})();

